export default {
  // 使能对话框
  toggleDialog(value) {
    this.visible = !!value;
  },
  // 更新表单
  updateFormModel() {
    this.formModel = JSON.parse(JSON.stringify(this.row));
    // console.log('model更新：', this.formModel);
  },

  async update(value) {
    // // 确认状态必须修改为非“待确认”
    // if (this.formModel.auditType === 0) {
    //   this.$message.warning('请求改确认状态选项');
    //   return;
    // }
    let v = value?1:0;
    // try {
    //   const confirm = await this.$confirm('是否确认修改？', '修改确认', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //   });
    //   if (confirm !== 'confirm') {
    //     return;
    //   }
    // } catch (e) {
    //   console.log('取消了处理修改');
    //   return;
    // }
    try {
      const input = {
        guid: this.formModel.guid,
        // auditMsg: this.formModel.auditMsg,
        dealType: v,   //v ? 1 : -1
        // stationCode: this.stationCode
      };
      let res = '';
      if (this.submitType === 'tradeMiss') {
        res = await this.http({ cmd: 'dataLose/deal', input });
      } else {
        res = await this.http({ cmd: 'vehicleTypeDifferent/deal', input });
      }
      if (res.code === '0') {
        this.$message.success(res.message);
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.visible = false;
      this.methods('emitUpdate');
    }
  },
  // 向父组件通知已经修改
  emitUpdate() {
    this.$emit('updated');
  }
};

